


export const LOAD_ROSTER = "LOAD_ROSTER";
export const LOAD_ROSTER_SUCCESS = "LOAD_ROSTER_SUCCESS";
export const LOAD_ROSTER_ERROR = "LOAD_ROSTER_ERROR";